<template>
  <div class="exchange">
    <!-- <h1>兑换中心</h1> -->
    <div class="hd">
      <div class="search-form">
        <el-input v-model="searchForm.goodName" size="mini" style="width: 200px;" placeholder="输入奖品名称进行搜索"></el-input>
        <el-button type="primary" size="mini" @click="fetchSearchGoodsList" style="margin: 0 380px 0 10px;">搜索</el-button>
        <el-select v-model="searchForm.label" placeholder="分类筛选" size="mini" clearable @change="fetchData">
          <el-option
            v-for="name in goodsLabelList"
            :key="name"
            :label="name"
            :value="name">
          </el-option>
        </el-select>
        <el-button class="sort" size="mini" @click="handleSortByCredits">按积分排序<i class="el-icon--right" :class="CREDITS_SORT_ICON_MAP[searchForm.priceSort]"></i></el-button>
      </div>
      <div class="tips">兑换规则：1、每月1号开放一次兑换窗口；</div>
      <div class="tips-no2">2、所有积分每年12.31日清零；</div>
      <div class="tips-no3">3、为保证个人、公司税务情况的合规合法，在积分商城兑换的礼品根据其现金价值计税申报</div>
    </div>
    <div class="product-list">
      <div class="product-cell" v-for="(item, index) in goodsList" :key="item.id" :title="item.name" @click="handelConfim(index)">
        <div class="figure">
          <!-- <a href="https://item.mi.com/product/8026.html" target="_blank" rel="noopener noreferrer"> -->
          <img :src="item.pic.replace(/https?:/, '')" :alt="item.name">
          <!-- </a> -->
          <!-- <span v-if="item.stock" class="exchange-btn" @click="handelExchange(index)">立即兑换</span> -->
          <span v-if="!item.stock" class="out-of-stock">暂无库存</span>
        </div>
        <div class="detail">
          <h3 class="title">{{item.name}}</h3>
          <p class="desc">{{item.desc}}</p>
          <p class="price">
            <strong>{{item.price}}</strong>
            积分
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import API from '@/apis'
import { Message } from 'element-ui'
import { decodeData } from '../utils/data'

const CREDITS_SORT_LIST = [
  'default',
  'up',
  'down'
]

const CREDITS_SORT_ICON_MAP = {
  default: 'el-icon-sort',
  up: 'el-icon-sort-up',
  down: 'el-icon-sort-down'
}

export default {
  name: 'exchange',
  data () {
    return {
      CREDITS_SORT_LIST,
      CREDITS_SORT_ICON_MAP,
      goodsList: [],
      searchForm: {
        priceSort: CREDITS_SORT_LIST[0],
        label: '',
        goodName: ''
      },
      goodsLabelList: [],
      form: {
        item: {},
        count: 1,
        remark: ''
      }
    }
  },
  computed: {
    ...mapState({
      email: state => state.email,
      userinfo: state => state.userinfo
    })
  },
  mounted () {
    this.fetchData()
    this.fetchGoodsLabelList()
  },
  methods: {
    handleSortByCredits () {
      const index = CREDITS_SORT_LIST.findIndex(item => item === this.searchForm.priceSort) + 1
      const newValue = CREDITS_SORT_LIST[index % CREDITS_SORT_LIST.length]
      this.searchForm.priceSort = newValue
      this.fetchGoodsList()
    },
    handelConfim (index) {
      const item = this.goodsList[index]
      this.form.item = item
      const h = this.$createElement
      this.$msgbox({
        title: '请确认兑换商品',
        message: h('div', null, [
          h('label', { class: 'el-form-item__label' }, '兑换数量：'),
          h('input', {
            on: {
              change: event => {
                this.form.count = Number(event.target.value)
              }
            },
            attrs: {
              class: 'el-input__inner',
              type: 'number',
              value: this.form.count,
              min: 1,
              max: 9
            }
          }),
          h('label', { class: 'el-form-item__label' }, '备注：'),
          h('pre', { class: 'el-form-item__label', style: `clear: both; margin: 0 0 10px; line-height: 1.5rem; text-align: left; color: #F56C6C;${item.remark ? '' : 'display:none;'}` }, decodeData(item.remark)),
          h('textarea', {
            on: {
              change: event => {
                this.form.remark = event.target.value
              }
            },
            attrs: {
              maxlength: 100,
              rows: 2,
              class: 'el-textarea__inner',
              style: 'min-height: 54px; height: 54px;'
            }
          })
        ]),
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.handelExchange()
      }).catch(() => {
        // NOTHING TODO
      })
    },
    async handelExchange () {
      let { item, count, remark } = this.form
      if (!count) {
        Message({
          showClose: true,
          message: '请输入兑换数~',
          type: 'error'
        })
        return
      }

      if (this.userinfo.credits < item.price * count) {
        Message({
          showClose: true,
          message: '非常抱歉，您的积分数不足~',
          type: 'error'
        })
        return
      }

      if (count > item.stock) {
        Message({
          showClose: true,
          message: '抱歉库存不足~',
          type: 'error'
        })
        return
      }

      if (item.remark && !remark) {
        Message({
          showClose: true,
          message: `请填写备注信息：${decodeData(item.remark)}`,
          type: 'error'
        })
        return
      }

      const type = 'createExchangeRecord'
      let res = await API.graphql({
        query: `
          mutation {
            ${type}(goods_id: ${item.id}, count: ${count}, remark: "${encodeURIComponent(remark)}") {
              ret
              msg
            }
          }
        `
      })

      let data = res.data[type]

      if (!data.ret) {
        // alert('恭喜兑换成功~，请耐心等候贴心的HR联系您~')
        Message({
          showClose: true,
          message: '恭喜兑换成功~，请耐心等候贴心的HR联系您~',
          type: 'success'
        })
      } else {
        // alert(data.msg)
        Message({
          showClose: true,
          message: data.msg,
          type: 'error'
        })
      }
    },
    async fetchGoodsLabelList () {
      let res = await API.getGoodsLabelList()

      this.goodsLabelList = res.data.rows
    },
    async fetchGoodsList () {
      let res = await API.graphql({
        query: `
          query {
            goodsList(status: 0, label: "${this.searchForm.label}", priceSort: "${this.searchForm.priceSort}") {
              rows {
                id
                name
                desc
                pic
                price
                stock
                remark
                label
              }
            }
          }
        `
      })

      this.goodsList = res.data.goodsList.rows
    },
    fetchData () {
      this.fetchGoodsList()
    },
    async fetchSearchGoodsList () {
      if (this.searchForm.goodName === '') {
        Message({
          showClose: true,
          message: '请输入奖品名称~',
          type: 'error'
        })
        return
      }
      let res = await API.graphql({
        query: `
          query {
            goodsList(
              limit: 0
              offset:0
              ${this.searchForm.goodName ? `name:"${this.searchForm.goodName.trim()}"` : ''}
              status: 0
            ) {
              rows {
                id
                name
                desc
                pic
                price
                stock
                remark
                label
              }
            }
          }
        `
      })

      if (res.data.goodsList.rows.length === 0) {
        Message({
          showClose: true,
          message: '未搜索到相关商品~',
          type: 'error'
        })
        return
      }

      this.goodsList = res.data.goodsList.rows
    }
  }
}
</script>

<style lang="scss" scoped>
.exchange {
  position: relative;
  min-height: 100vh;
  &::after {
    content: '';
    position: absolute;
    right: -460px;
    top: -98px;
    width: 690px;
    height: 580px;
    background: url('~@/assets/bg2.png') right 0 no-repeat;
    background-size: auto 100%;
  }
}

h1 {
  height: 50vh;
  line-height: 50vh;
  text-align: center;
  font-size: 20vh;
}

.hd {
  position: relative;
  width: 940px;
  margin: 0 auto;
}

.tips {
  margin-top: 20px;
  font-size: 12px;
  color: #999;
}
.tips-no2 {
  font-size: 12px;
  color: #999;
  padding-left: 60px;
}
.tips-no3 {
  font-size: 12px;
  color: #ff6022;
  margin-left: 60px;
  background-color: #fdf7c8;
  width: 500px;
  border-radius: 4px;
}
.search-form {
  position: relative;
  z-index: 1;
  .sort {
    margin-left: 10px;
  }
}

.product-list {
  position: relative;
  z-index: 2;
  width: 940px;
  margin: 0 auto;
  padding: 60px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
}

.product-cell {
  position: relative;
  float: left;
  width: 450px;
  height: 370px;
  margin-bottom: 40px;
  background: #fff;
  box-shadow: 0px 8px 20px 0px rgba(216,220,246,0.32);
  cursor: pointer;
  &:nth-child(2n) {
    margin-left: 40px;
  }
  .figure {
    position: relative;
    height: 270px;
    overflow: hidden;
    &:hover {
      .exchange-btn {
        right: 10px;
      }
    }
    img {
      width: 100%;
    }
    .exchange-btn {
      position: absolute;
      right: -120px;
      bottom: 10px;
      background: #ea4809;
      border-radius: 17px;
      padding: 7px 15px;
      cursor: pointer;
      color: #fff;
      transition: 0.2s cubic-bezier(0.65, 0, 0.17, 0.98);
    }
    .out-of-stock {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      line-height: 358px;
      text-align: center;
      font-size: 30px;
      text-shadow: 1px 1px 1px #FFF;
      color: #333;
      background: rgba(255,255,255,.7);
    }
  }
  .detail {
    height: 100px;
  }
  .title {
    width: 280px;
    font-weight: 400;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 26px;
    margin: 25px 0 0 30px;
    overflow: hidden;
    font-size: 16px;
    color: #333;
    a {
      text-decoration: none;
      color: rgba(51,51,51,.9);
    }
  }
  .desc {
    line-height: 18px;
    margin: 3px 0 0 30px;
    font-size: 10px;
    color: #888;
  }
  .price {
    line-height: 30px;
    color: #FF6022;
    font-size: 12px;
    font-weight: 700;
    position: absolute;
    right: 48px;
    bottom: 30px;
    margin: 0;
    strong {
      font-weight: 400;
      font-size: 24px;
    }
  }
}
</style>
